import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptorParams } from '@app/core/interceptors/classes/http-interceptor-params';
import { TranslationObject } from '@ngx-translate/core';
import { environment } from '@environment';
import { I18nMockService } from '@mock/data-services/i18n-mock.service';

@Injectable({
  providedIn: 'root',
})
export class I18nApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly MOCK: I18nMockService
  ) {}

  public getDefaultLocalTranslate(): Observable<TranslationObject> {
    const url = `/locale/default.json?date=${+new Date()}`; // prevent caching data

    return this.httpClient.get<TranslationObject>(url, {
      params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreNavigationCancellation: true }),
    });
  }

  public getTranslationObjectFromServer(lang: string): Observable<TranslationObject> {
    if (this.MOCK.isI18nMockEnabled()) return this.MOCK.getTranslationObject(lang);

    const url = `${environment.apiBaseUrl}/v1/i18n/${lang}.json?date=${+new Date()}`; // prevent caching data

    return this.httpClient.get<TranslationObject>(url, {
      params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreNavigationCancellation: true }),
    });
  }
}
